/**
 * 
 * leaflet 自带的canvas引擎在缩放和移动的时候只会引起局部刷新
 * @see https://github.com/Sumbera/gLayers.Leaflet
 */
L.CanvasLayer = L.Layer.extend({
	/**
	 * 初始化
	 */
	initialize: function (options) {
		this._map = null;
		this._canvas = null;
		this._frame = null;
		this._delegate = null;
		L.setOptions(this, options);
	},
	/**
	 * 委托
	 */
	delegate: function (del) {
		this._delegate = del;
		return this;
	},

	needRedraw: function () {
		if (!this._frame) {
			this._frame = L.Util.requestAnimFrame(this.drawLayer, this);
		}
		return this;
	},

	//-------------------------------------------------------------
	_onLayerDidResize: function (resizeEvent) {
		this._canvas.width = resizeEvent.newSize.x;
		this._canvas.height = resizeEvent.newSize.y;
	},
	//-------------------------------------------------------------
	_onLayerDidMove: function () {
		var topLeft = this._map.containerPointToLayerPoint([0, 0]);
		L.DomUtil.setPosition(this._canvas, topLeft);
		this.drawLayer();
	},
	//-------------------------------------------------------------
	getEvents: function () {
		var events = {
			resize: this._onLayerDidResize,
			moveend: this._onLayerDidMove
		};
		if (this._map.options.zoomAnimation && L.Browser.any3d) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},
	//-------------------------------------------------------------
	onAdd: function (map) {
		this._map = map;
		this._canvas = T.canvas('leaflet-layer');
		this.tiles = {};

		var size = this._map.getSize();
		this._canvas.width = size.x;
		this._canvas.height = size.y;

		var animated = this._map.options.zoomAnimation && L.Browser.any3d;
		L.DomUtil.addClass(this._canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));


		map._panes.overlayPane.appendChild(this._canvas);
		map.on(this.getEvents(), this);

		var del = this._delegate || this;
		del.onLayerDidMount && del.onLayerDidMount(); // -- callback
		this.needRedraw();

		var self = this;
		setTimeout(function () {
			self._onLayerDidMove();
		}, 0);
	},

	//-------------------------------------------------------------
	onRemove: function (map) {
		var del = this._delegate || this;
		del.onLayerWillUnmount && del.onLayerWillUnmount(); // -- callback

		map.getPanes().overlayPane.removeChild(this._canvas);

		map.off(this.getEvents(), this);

		this._canvas = null;

	},

	//------------------------------------------------------------
	addTo: function (map) {
		map.addLayer(this);
		return this;
	},
	// --------------------------------------------------------------------------------
	LatLonToMercator: function (latlon) {
		return {
			x: latlon.lng * 6378137 * Math.PI / 180,
			y: Math.log(Math.tan((90 + latlon.lat) * Math.PI / 360)) * 6378137
		};
	},

	//------------------------------------------------------------------------------
	drawLayer: function () {
		let { _map: map } = this;
		// -- todo make the viewInfo properties  flat objects.
		var size = map.getSize();
		var bounds = map.getBounds();
		var zoom = map.getZoom();

		var center = this.LatLonToMercator(map.getCenter());
		var corner = this.LatLonToMercator(map.containerPointToLatLng(map.getSize()));

		var del = this._delegate || this;
		del.onDrawLayer && del.onDrawLayer({
			layer: this,
			canvas: this._canvas,
			bounds: bounds,
			size: size,
			zoom: zoom,
			center: center,
			corner: corner
		});
		this._frame = null;
	},
	_animateZoom: function (e) {
		var scale = this._map.getZoomScale(e.zoom);
		var offset = this._map._latLngToNewLayerPoint(this._map.getBounds().getNorthWest(), e.zoom, e.center)
		L.DomUtil.setTransform(this._canvas, offset, scale);
	}
});

L.canvasLayer = function () {
	return new L.CanvasLayer();
};


// WEBPACK FOOTER //
// ./src/polyfill/L.CanvasLayer.js